<template>
    <iconTabs v-model="activeTab" nav-style="tabs">
        <iconTab header="Console" leftIcon="list-alt">
            <console></console>
        </iconTab>
        <div v-if="session != null">
            <iconTab :header="agentTypeName" leftIcon="user-secret" :rightIcon="agentType.state.tabIcon" v-for="(agentType, agentTypeName, index) in session.agentMap" :key="agentType.name">
                <codearea :agentType="agentType" @focus="activateAgentTab(index)"></codearea>
            </iconTab>
        </div>
    </iconTabs>
</template>

<script>
    import codearea from 'components/workbench/editor/Codearea'
    import iconTabs from 'components/utils/vuestrap/IconTabs'
    import iconTab from 'components/utils/vuestrap/IconTab'
    import console from 'components/console/Console'

    export default {
        name: "editorTabs",
        data() {
            return {
                activeTab: 0,
                session: null
            }
        },
        mounted() {
        },
        methods: {
            setSession(session) {
                this.session = session;
                this.activateAgentTab(0);
            },
            activateTab(tabIndex) {
                this.activeTab = tabIndex;
            },
            activateAgentTab(agentIndex) {
                this.activateTab(agentIndex + 1);
            }
        },
        components: {
            codearea,
            iconTabs,
            iconTab,
            console
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// EditorTabs.vue?94f043bc